import { useIntl } from "@umijs/max";

export interface AgentLevelInfo {
  label: string;
  color: string;
}

/**
 * 获取代理层级标签信息
 * @param level 层级 (1: 平台, 2: 一级代理, 3: 二级代理, 4: 商户)
 * @param intl 国际化对象
 * @returns {AgentLevelInfo} 包含文本和颜色的对象
 */
export const getAgentLevelInfo = (
  level: number | undefined,
  intl: any,
): AgentLevelInfo => {
  switch (level) {
    case 1:
      return {
        label: intl.formatMessage({ id: "component.agentLevel.platform" }),
        color: "blue",
      };
    case 2:
      return {
        label: intl.formatMessage({ id: "component.agentLevel.level1" }),
        color: "cyan",
      };
    case 3:
      return {
        label: intl.formatMessage({ id: "component.agentLevel.level2" }),
        color: "orange",
      };
    case 4:
      return {
        label: intl.formatMessage({ id: "component.agentLevel.merchant" }),
        color: "magenta",
      };
    default:
      return {
        label: intl.formatMessage({
          id: "pages.common.unknown",
          defaultMessage: "Unknown",
        }),
        color: "default",
      };
  }
};

/**
 * Hook 版本的获取代理层级标签信息
 */
export const useAgentLevelInfo = () => {
  const intl = useIntl();
  return (level: number | undefined) => getAgentLevelInfo(level, intl);
};
